import React, { useState, useEffect } from 'react';
import axios from 'axios';

import Cart from './Cart';
import AddToCart from './AddToCart';

const Sticker = (props) => {
  return <img src={require('../images/etiquete_' + props.name + '.svg')} />
}

const Shop = (props) => {

  const [items, setItems] = useState([])

  useEffect(() => {fetchData()}, []);

  const fetchData = async () => {
    const result = await axios('/cart')
    setItems(result.data);
  }

  const add = (id, extra) => {
    const extra_param = extra ? '?type=sub' : ''
    axios.get('/cart/buy/' + id + extra_param).then(() => fetchData())
  }

  const getDays = (str) => {
    if(str === 'Danas') {
      return 1
    } else {
      return parseInt(str.split(' ')[1])
    }
  }

  return <div className='product_posts'>
    <Cart items={items} fetchData={fetchData} />
    {props.products.map((product) =>
      <article key={product.id} className="product_post">
        <div className="product_post_header">
          {product.image.url &&
          <div className="product_image">
            <img src={product.image.small.url} name={product.name_hr} />
          </div>
          }
          <div className="product_post_etiquetes">
            {product.marks.map((mark) =>
              <Sticker key={mark.id} name={mark.name_hr} />
            )}
          </div>
        </div>
        <div className="product_post_body">
          <h4 className="product_post_producer">{product.merchant.name_hr}</h4>
          <h3 className="product_post_title">{product.name_hr}</h3>
          <p className="product_post_lead" dangerouslySetInnerHTML={{
            __html: product.description_hr.replace(/<[^>]+>/g, '').replace('\n', '<br><br>')
          }}>
          </p>
          <div className="order_deadline">
            <h4>rok za narudžbu</h4>
            <div className="deadline_date">
              <span dangerouslySetInnerHTML={{ __html: product.order_date}}></span>
              {(getDays(product.available_to_days) > 0) &&
                <span className="days_remaining">{product.available_to_days}</span>
              }
            </div>
          </div>
          {product.price_label &&
          <div className="product_price"><span>{product.price_label}</span></div>
          }
          {!product.price_label &&
          <div className="product_price"><span>{product.not_tax_price.toFixed(2)} kn / {product.unit.name_hr}</span></div>
          }
        </div>
        <AddToCart
          id={product.id}
          unit={product.unit.description_hr}
          stock={product.stock}
          stockTag={product.stock_tag}
          availableToDays={getDays(product.available_to_days)}
          add={add} />
      </article>
    )}
  </div>

}

export default Shop



// WEBPACK FOOTER //
// app/frontend/components/Shop.jsx